export const tagTypes = {
  UnitPendingLeadershipPositions: 'UnitPendingLeadershipPositions',
  UnitLeadershipPositions: 'UnitLeadershipPositions',
  YouthRankVersionDetails: 'YouthRankVersionDetails',
  AdventureUserRequirements: 'AdventureUserRequirements',
  AwardUserRequirements: 'AwardUserRequirements',
  MeritBadgeUserRequirements: 'MeritBadgeUserRequirements',
  OrganizationProfile: 'OrganizationProfile',
  OrganizationPaymentProfile: 'OrganizationPaymentProfile',
  OrganizationAdvDashboard: 'OrganizationAdvDashboard',
  OrganizationActivitiesDashboard: 'OrganizationActivitiesDashboard',
  RankDetails: 'RankDetails',
  RankRequirements: 'RankRequirements',
  AwardRequirements: 'AwardRequirements',
  AdventureRequirements: 'AdventureRequirements',
  YouthLeadershipPositions: 'YouthLeadershipPositions',
  YouthRankDetails: 'YouthRankDetails',
  YouthRankRequirements: 'YouthRankRequirements',
  YouthAwardRequirements: 'YouthAwardRequirements',
  YouthAdventureRequirements: 'YouthAdventureRequirements',
  PersonRenewalRelationships: 'PersonRenewalRelationships',
  PersonProfile: 'PersonProfile',
  PersonMystProfile: 'PersonMystProfile',
  PersonSubscriptions: 'PersonSubscriptions',
  CompletePersonProfile: 'CompletePersonProfile',
  SbEducationRecords: 'SbEducationRecords',
  SbExtendedProfiles: 'SbExtendedProfiles',
  AdvancementHistory: 'AdvancementHistory',
  PaymentLogSummary: 'PaymentLogSummary',
  PaymentLogBalance: 'PaymentLogBalance',
  PaymentLogQuery: 'PaymentLogQuery',
  PaymentLogCategories: 'PaymentLogCategories',
  PaymentLogComments: 'PaymentLogComments',
  PersonTrainingYPT: 'PersonTrainingYPT',
  UnitDenchiefs: 'UnitDenchiefs',
  BulkMeritBadgeBlueCard: 'BulkMeritBadgeBlueCard',
  MeritBadgeCounselorProfile: 'MeritBadgeCounselorProfile',
  MBCDashboard: 'MBCDashboard',
  MBCAssignedToYouth: 'MBCAssignedToYouth',
  MBCClasses: 'MBCClasses',
  SubUnits: 'SubUnits',
  UnitRoster: 'UnitRoster',
  OrganizationRoster: 'OrganizationRoster',
  PurchaseOrders: 'PurchaseOrders',
  OrgAdvancementsReadyToAward: 'OrgAdvancementsReadyToAward',
  OrganizationPositions: 'OrganizationPositions',
  AdvancementImports: 'AdvancementImports',
  RelationshipSearch: 'RelationshipSearch',
  UserRoleTypes: 'UserRoleTypes',
  MembershipRegistration: 'MembershipRegistration',
  UnitRenewalOrders: 'UnitRenewalOrders',
  MerchantStatuses: 'MerchantStatuses',
  AdvancementComment: 'AdvancementComment',
  // Arnica
  ReportsList: 'ReportsList',
  CustomReports: 'CustomReports',
  CustomRosterReports: 'CustomRosterReports',
  UnitRosterLiteReport: 'UnitRosterLiteReport',
  // Collections
  Awards: 'Awards',
  Activities: 'Activities',
  MeritBadges: 'MeritBadges',
  AkelaMeritBadges: 'AkelaMeritBadges',
  Adventure: 'Adventure',
  Rank: 'Rank',
  Event: 'Event',
  AdvancementDetails: 'AdvancementDetails',
  PermissionSlips: 'PermissionSlips',
  UnitEvents: 'UnitEvents',
  UnitEventHealthMetrics: 'UnitEventHealthMetrics',
  YouthAdventure: 'YouthAdventure',
  YouthAward: 'YouthAward',
  YouthMeritBadge: 'YouthMeritBadge',
  YouthRanks: 'YouthRanks',
  YouthSSElectives: 'YouthSSElectives',
  UnitSearchResult: 'UnitSearch',
  ImportMBFile: 'ImportMBFile',
  UserActivitySummary: 'UserActivitySummary',
  ParentGuardianInvitation: 'ParentGuardianInvitation',
  Relationships: 'Relationships',
  // CASS
  PreciselyToken: 'PreciselyToken',
  CASSAutocomplete: 'CASSAutocomplete',
  // Lookups
  LookupOptoutReasons: 'LookupOptoutReasons',
  LookupAdvancementPositions: 'LookupAdvancementPositions',
  LookupSwimmingCalssifications: 'LookupSwimmingCalssifications',
  LookupPersonPositions: 'LookupPersonPositions',
  LookupActivityCategories: 'LookupActivityCategories',
  LookupActivityCollabOrgs: 'LookupActivityCollabOrgs',
  // Events
  EventsCommunications: 'EventsCommunications',
} as const;
